export default [
  {
    "id": "mat-enem-0130",
    "numero": 1630,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Muitas indústrias têm procurado modificar as \nembalagens de seus produtos de forma a eco-\nnomizar material, mas mantendo o mesmo vo-\nlume. Considere que se tenha uma folha de \npapelão quadrada e se deseje encontrar a me-\nlhor altura (h) para fazer uma caixa sem tampa, \ncortando-se os quatro cantos da folha. As exi-\ngências são que as dimensões da caixa sejam \nnúmeros inteiros e que o volume seja o maior \npossível. No modelo apresentado na figura se-\nguinte, a folha tem 12 cm de lado e, nesse caso, \na caixa de maior volume terá altura 2 cm. Para \nencontrar esse número, é calculado o volume \nem função da altura e prossegue-se atribuindo \nvalores a h e calculando o volume, enquanto o \nvalor do volume aumentar. \n \n \n \nSe a folha quadrada tiver 20 cm de lado, qual \ndeve ser a medida do lado do quadrado a ser \ncortado em cada um dos cantos, de modo a \nobter uma caixa sem tampa cujas dimensões \nsejam números inteiros e cujo volume seja o \nmaior possível? \n \nA) 6 cm \nB) 3 cm \nC) 5 cm \nD) 2 cm \nE) 4 cm",
    "alternativas": {
      "C": "5 cm",
      "D": "2 cm",
      "E": "4 cm",
      "B": "3 cm"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 130,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0131",
    "numero": 1631,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "O quadro a seguir apresenta dados sobre a frota de veículos, e as estatísticas de acidentes de trânsito \nno Brasil no período compreendido entre 2003 e 2006. \n \n \n \nSuponha que, em 2006, o indicador relativo à quantidade de acidentes com vítimas a cada 10.000 veícu-\nlos tenha sido a média dos valores correspondentes a esse indicador nos anos de 2003 a 2005. Nesse \ncaso, o total de acidentes com vítimas ocorridos em 2006 foi igual a: \n \nA) 413.594. \nB) 353.932. \nC) 408.600. \nD) 399.066 \nE) 433.053.",
    "alternativas": {
      "C": "408.600.",
      "D": "399.066",
      "E": "433.053.",
      "A": "413.594."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 131,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0132",
    "numero": 1632,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Adultos e crianças têm o hábito de colecionar \nminiaturas de carros. Vários padrões de coleção \nsão encontrados, desde modelos com marcas \nespecíficas até modelos de um determinado \nperíodo. A “fidelidade” ao modelo original das \nminiaturas encanta qualquer pessoa, isso é \npossível, entre outros itens, pela “obediência” às \nproporções de um veículo original. São encon-\ntrados carros em miniatura numa escala de 1:90 \nou 1:45. \nMiniaturas M1 e M2 de um carro, do mesmo \nmodelo, foram confeccionadas, respectivamen-\nte, nas escalas 1:90 e 1:45. Que relação existe \nentre a área da superfície das duas miniaturas? \n \nA) área de M1 = 8 × (área de M2) \nB) área de M1 = 4 × (área de M2) \nC) área de M1 = 2 × (área de M2) \n \nD) área de M1 = \n1\n4 × (área de M2) \n \nE) área de M1 = \n1\n2 × (área de M2)",
    "alternativas": {
      "B": "área de M1 = 4 × (área de M2)",
      "D": "área de M1 = 1 4 × (área de M2)",
      "E": "área de M1 = 1 2 × (área de M2)",
      "A": "área de M1 = 8 × (área de M2)"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 132,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0133",
    "numero": 1633,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Os alunos de uma escola fizeram uma rifa para \narrecadação de fundos para uma festa junina. \nOs 1.000 bilhetes da rifa foram numerados com \nos múltiplos de 3, iniciando-se com o número 3. \nSerão sorteados, aleatoriamente, 3 números, \ncorrespondendo ao primeiro, ao segundo e ao \nterceiro prêmios. \n \nA probabilidade de o número do primeiro bilhete \nsorteado ser par e maior que 2.991 é igual a: \n \nA) 0,003. \nB) 0,005. \nC) 0,004. \nD) 0,002. \nE) 0,001.",
    "alternativas": {
      "B": "0,005.",
      "C": "0,004.",
      "D": "0,002.",
      "A": "0,003."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 133,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0135",
    "numero": 1635,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Maomé comandou a unificação política e religi-\nosa da Arábia. Sua saída de Meca para Medina \né chamada de Hégira, que, ocorrida no ano de \n622 d.C., marcou o início da cronologia muçul-\nmana. \n \nPara se converter a data do calendário muçul-\nmano para o calendário gregoriano, é necessá-\nrio considerar, inicialmente, que, entre o ano \nlunar muçulmano e o ano gregoriano, existe \numa diferença de 97 dias em cada século. Des-\nsa forma, o ano de 1400, no calendário muçul-\nmano, corresponde, no calendário gregoriano, \naproximadamente, ao ano de: \n \nA) 1980 d.C. \nB) 635 d.C. \nC) 1961 d.C. \nD) 637 d.C. \nE) 755 d.C.",
    "alternativas": {
      "D": "637 d.C.",
      "E": "755 d.C.",
      "A": "1980 d.C.",
      "C": "1961 d.C."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2009.3",
    "numeroOriginal": 135,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0137",
    "numero": 1637,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "No monte de Cerro Armazones, no deserto de \nAtacama, no Chile, ficará o maior telescópio da \nsuperfície terrestre, o Telescópio Europeu Ex-\ntremamente Grande (E-ELT). O E-ELT terá um \nespelho primário de 42 m de diâmetro, “o maior \nolho do mundo voltado para o céu”. Ao ler esse \ntexto em uma sala de aula, uma professora fez \numa suposição de que o diâmetro do olho hu-\nmano mede aproximadamente 2,1 cm.  \n \nQual a razão entre o diâmetro aproximado do \nolho humano, suposto pela professora, e o diâ-\nmetro do espelho primário do telescópio citado? \n \nA) 1 : 20        \nB) 1 : 100        \nC) 1 : 200        \nD) 1 : 1 000        \nE) 1 : 2 000",
    "alternativas": {
      "B": "1 : 100",
      "D": "1 : 1 000",
      "E": "1 : 2 000",
      "A": "1 : 20"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 137,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0139",
    "numero": 1639,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Uma fábrica produz barras de chocolates no \nformato de paralelepípedos e de cubos, com o \nmesmo volume.  As arestas da barra de choco-\nlate no formato de paralelepípedo medem 3 cm \nde largura, 18 cm de comprimento e 4 cm de \nespessura. \n \nAnalisando as características das figuras geo-\nmétricas descritas, a medida das arestas dos \nchocolates que têm o formato de cubo é igual a \n \nA) 5 cm.        \nB) 6 cm.        \nC) 12 cm.         \nD) 24 cm.         \nE) 25 cm.",
    "alternativas": {
      "B": "6 cm.",
      "C": "12 cm.",
      "D": "24 cm.",
      "A": "5 cm."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 139,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0140",
    "numero": 1640,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "A classificação de um país no quadro de meda-\nlhas nos Jogos Olímpicos depende do número \nde medalhas de ouro que obteve na competi-\nção, tendo como critérios de desempate o nú- \nmero de medalhas de prata seguido do número \nde medalhas de bronze conquistados. Nas \nOlimpíadas de 2004, o Brasil foi o décimo sexto \ncolocado no quadro de medalhas, tendo obtido \n5 medalhas de ouro, 2 de prata e 3 de bronze. \nParte desse quadro de medalhas é reproduzida \na seguir. \n \n \n \nSe o Brasil tivesse obtido mais 4 medalhas de \nouro, 4 de prata e 10 de bronze, sem alteração \nno número de medalhas dos demais países \nmostrados no quadro, qual teria sido a classifi-\ncação brasileira no quadro de medalhas das \nOlimpíadas de 2004? \n \nA) 13º        \nB) 12º         \nC) 11º           \nD) 10º          \nE) 9º",
    "alternativas": {
      "E": "9º",
      "B": "12º",
      "C": "11º",
      "D": "10º"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 140,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0141",
    "numero": 1641,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Os dados do gráfico foram coletados por meio \nda Pesquisa Nacional por Amostra de Domicí-\nlios. \n \n \n \nSupondo-se que, no Sudeste, 14 900 estudan-\ntes foram entrevistados nessa pesquisa, quan-\ntos deles possuíam telefone móvel celular? \n \nA) 5 513       \nB) 6 556        \nC) 7 450        \nD) 8 344        \nE) 9 536",
    "alternativas": {
      "D": "8 344",
      "E": "9 536",
      "A": "5 513",
      "C": "7 450"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 141,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0143",
    "numero": 1643,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Em sete de abril de 2004, um jornal publicou o \nranking de desmatamento, conforme o gráfico, \nda chamada Amazônia Legal, integrada por \nnove estados. \n \n \n \nConsiderando-se que até 2009 o desmatamento \ncresceu 10,5% em relação aos dados de 2004, \no desmatamento médio por estado em 2009 \nestá entre: \n \nA) 100 km² e 900 km². \nB) 1 000 km² e 2 700 km². \nC) 2 800 km² e 3 200 km². \nD) 3 300 km² e 4 000 km². \nE) 4 100 km² e 5 800 km².",
    "alternativas": {
      "A": "100 km² e 900 km².",
      "B": "1 000 km² e 2 700 km².",
      "C": "2 800 km² e 3 200 km².",
      "E": "4 100 km² e 5 800 km²."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 143,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0144",
    "numero": 1644,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "A resistência elétrica e  \nas dimensões do condutor \n \n \n \nA relação da resistência elétrica com as dimen-\nsões do condutor foi estudada por um grupo de \ncientistas por meio de vários experimentos de \neletricidade. Eles verificam que existe proporci-\nonalidade entre: \n \n- resistência (R) e comprimento (l), dada a \nmesma secção transversal (A); \n \n- resistência (R) e área da secção transversal \n(A), dado o mesmo comprimento (l); \n \n- comprimento (l) e área da secção transversal \n(A), dada a mesma resistência (R). \n \nConsiderando os resistores como fio, pode-se \nexemplificar o estudo das grandezas que influ-\nem na resistência elétrica utilizando as figuras \nseguintes. \nAs figuras mostram que as proporcionalidades \nexistentes entre Resistência (R) e comprimento \n(l), Resistência (R) e área de secção transversal \n(A) e entre comprimento (l) e área de secção \ntransversal (A) são, respectivamente, \n \nA) direta, direta e direta. \nB) direta, direta e inversa. \nC) direta, inversa e direta. \nD) inversa, direta e direta. \nE) inversa, direta e inversa.",
    "alternativas": {
      "B": "direta, direta e inversa.",
      "C": "direta, inversa e direta.",
      "D": "inversa, direta e direta.",
      "A": "direta, direta e direta."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 144,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0145",
    "numero": 1645,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Os dados do gráfico seguinte foram gerados a \npartir de dados colhidos no conjunto de seis \nregiões metropolitanas pelo Departamento In-\ntersindical de Estatística e Estudos Socioeco-\nnômicos (DIEESE). \n \n \n \nSupondo que o total de pessoas pesquisadas \nna região metropolitana de Porto Alegre equiva-\nle a 250 000, o número de desempregados em \nmarço de 2010, nessa região, foi de: \n \nA) 24 500.        \nB) 25 000.        \nC) 220 500.        \nD) 223 000.        \nE) 227 500.",
    "alternativas": {
      "A": "24 500.",
      "C": "220 500.",
      "D": "223 000.",
      "E": "227 500."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 145,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0146",
    "numero": 1646,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "A siderúrgica “Metal Nobre” produz diversos \nobjetos maciços utilizando o ferro. Um tipo es-\npecial de peça feita nessa companhia tem o \nformato de um paralelepípedo retangular, de \nacordo com as dimensões indicadas na figura \nque segue. \nO produto das três dimensões indicadas na \npeça resultaria na medida da grandeza: \n \nA) massa.       \nB) volume.       \nC) superfície.       \nD) capacidade.       \nE) comprimento.",
    "alternativas": {
      "A": "massa.",
      "B": "volume.",
      "D": "capacidade.",
      "E": "comprimento."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 146,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0147",
    "numero": 1647,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "A figura I abaixo mostra um esquema das prin-\ncipais vias que interligam a cidade A com a ci-\ndade B. Cada número indicado na figura II re-\npresenta a probabilidade de pegar um engarra-\nfamento quando se passa na via indicada. As-\nsim, há uma probabilidade de 30% de se pegar \nengarrafamento no deslocamento do ponto C ao \no ponto B, passando pela estrada E4, e de 50%, \nquando se passa por E3. Essas probabilidades \nsão independentes umas das outras. \n \n \n \nPaula deseja se deslocar da cidade A para a \ncidade B usando exatamente duas das vias \nindicadas, percorrendo um trajeto com a menor \nprobabilidade de engarrafamento possível. O \nmelhor trajeto para Paula é:  \n \nA) E1E3.        \nB) E1E4.        \nC) E2E4.        \nD) E2E5.        \nE) E2E6.",
    "alternativas": {
      "A": "E1E3.",
      "B": "E1E4.",
      "D": "E2E5.",
      "E": "E2E6."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 147,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0148",
    "numero": 1648,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "O gráfico a seguir representa o gasto militar dos Estados Unidos, no período de 1988 a 2006. \n \n \n \nCom base no gráfico, o gasto militar no início da guerra no Iraque foi de: \n \nA) U$ 4.174.000,00. \nB) U$ 41.740.000,00. \nC) U$ 417.400.000,00. \nD) U$ 41.740.000.000,00. \nE) U$ 417.400.000.000,00.",
    "alternativas": {
      "A": "U$ 4.174.000,00.",
      "B": "U$ 41.740.000,00.",
      "C": "U$ 417.400.000,00.",
      "E": "U$ 417.400.000.000,00."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 148,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0149",
    "numero": 1649,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Uma professora realizou uma atividade com \nseus alunos utilizando canudos de refrigerante \npara montar figuras, onde cada lado foi repre-\nsentado por um canudo. A quantidade de canu-\ndos (C) de cada figura depende da quantidade \nde quadrados (Q) que formam cada figura. A \nestrutura de formação das figuras está repre-\nsentada a seguir. \nQue expressão fornece a quantidade de canu-\ndos em função da quantidade de quadrados de \ncada figura? \n \nA) C = 4Q        \nB) C = 3Q + 1        \nC) C = 4Q - 1        \nD) C = Q + 3        \nE) C = 4Q - 2",
    "alternativas": {
      "D": "C = Q + 3",
      "A": "C = 4Q",
      "B": "C = 3Q + 1",
      "C": "C = 4Q - 1"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 149,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0150",
    "numero": 1650,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "A loja Telas & Molduras cobra 20 reais por me-\ntro quadrado de tela, 15 reais por metro linear \nde moldura, mais uma taxa fixa de entrega de \n20 reais. \n \nUma artista plástica precisa encomendar telas e \nmolduras a essa loja, suficientes para 8 quadros \nretangulares (25 cm × 50 cm). Em seguida, fez \numa segunda encomenda, mas agora para 8 \nquadros retangulares (50 cm × 100 cm). O valor \nda segunda encomenda será: \n \nA) o dobro do valor da primeira encomenda, \nporque a altura e a largura dos quadros dobra-\nram.  \nB) maior do que o valor da primeira encomenda, \nmas não o dobro. \nC) a metade do valor da primeira encomenda, \nporque a altura e a largura dos quadros dobra-\nram. \nD) menor do que o valor da primeira encomen-\nda, mas não a metade. \nE) igual ao valor da primeira encomenda, por-\nque o custo de entrega será o mesmo.",
    "alternativas": {
      "C": "a metade do valor da primeira encomenda, porque a altura e a largura dos quadros dobra- ram.",
      "D": "menor do que o valor da primeira encomen- da, mas não a metade.",
      "E": "igual ao valor da primeira encomenda, por- que o custo de entrega será o mesmo.",
      "B": "maior do que o valor da primeira encomenda, mas não o dobro."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 150,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0151",
    "numero": 1651,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Dona Maria, diarista na casa da família Teixeira, \nprecisa fazer café para servir as vinte pessoas \nque se encontram numa reunião na sala. Para \nfazer o café, Dona Maria dispõe de uma leiteira \ncilíndrica e copinhos plásticos, também cilíndri-\ncos. \n \n \n \nCom o objetivo de não desperdiçar café, a dia-\nrista deseja colocar a quantidade mínima de \nágua na leiteira para encher os vinte copinhos \npela metade. Para que isso ocorra, Dona Maria \ndeverá: \nA) encher a leiteira até a metade, pois ela tem \num volume 20 vezes maior que o volume do \ncopo. \nB) encher a leiteira toda de água, pois ela tem \num volume 20 vezes maior que o volume do \ncopo. \nC) encher a leiteira toda de água, pois ela tem \num volume 10 vezes maior que o volume do \ncopo. \nD) encher duas leiteiras de água, pois ela tem \num volume 10 vezes maior que o volume do \ncopo. \nE) encher cinco leiteiras de água, pois ela tem \num volume 10 vezes maior que o volume do \ncopo.",
    "alternativas": {
      "D": "encher duas leiteiras de água, pois ela tem um volume 10 vezes maior que o volume do copo.",
      "E": "encher cinco leiteiras de água, pois ela tem um volume 10 vezes maior que o volume do copo.",
      "A": "encher a leiteira até a metade, pois ela tem um volume 20 vezes maior que o volume do copo.",
      "C": "encher a leiteira toda de água, pois ela tem um volume 10 vezes maior que o volume do copo."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 151,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0152",
    "numero": 1652,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Um satélite de telecomunicações, t minutos \napós ter atingido sua órbita, está a r quilômetros \nde distância do centro da Terra. Quando r as-\nsume seus valores máximo e mínimo, diz-se \nque o satélite atingiu o apogeu e o perigeu, res-\npectivamente. Suponha que, para esse satélite, \no valor de r em função de t seja dado por: \n \n \n \nUm cientista monitora o movimento desse satéli-\nte para controlar o seu afastamento do centro \nda Terra. Para isso, ele precisa calcular a soma \ndos valores de r, no apogeu e no perigeu, re-\npresentada por S. \n \nO cientista deveria concluir que, periodicamen-\nte, S atinge o valor de: \n \nA) 12 765 km.        \nB) 12 000 km.        \nC) 11 730 km.        \nD) 10 965 km.        \nE) 5 865 km.",
    "alternativas": {
      "D": "10 965 km.",
      "E": "5 865 km.",
      "A": "12 765 km.",
      "B": "12 000 km."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 152,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0153",
    "numero": 1653,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Uma empresa vende tanques de combustíveis \nde formato cilíndrico, em três tamanhos, com \nmedidas indicadas nas figuras. O preço do tan-\nque é diretamente proporcional à medida da \nárea da superfície lateral do tanque. O dono de \num posto de combustível deseja encomendar \num tanque com menor custo por metro cúbico \nde capacidade de armazenamento. \nQual dos tanques deverá ser escolhido pelo \ndono do posto?                           (Considere 𝜋≅3) \n \nA) I, pela relação área/capacidade de armaze-\nnamento de 1/3. \nB) I, pela relação área/capacidade de armaze-\nnamento de 4/3. \nC) II, pela relação área/capacidade de armaze-\nnamento de 3/4. \nD) III, pela relação área/capacidade de armaze-\nnamento de 2/3. \nE) III, pela relação área/capacidade de armaze-\nnamento de 7/12.",
    "alternativas": {
      "B": "I, pela relação área/capacidade de armaze- namento de 4/3.",
      "C": "II, pela relação área/capacidade de armaze- namento de 3/4.",
      "D": "III, pela relação área/capacidade de armaze- namento de 2/3.",
      "A": "I, pela relação área/capacidade de armaze- namento de 1/3."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 153,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0154",
    "numero": 1654,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Uma empresa possui um sistema de controle de \nqualidade que classifica o seu desempenho \nfinanceiro anual, tendo como base o do ano \nanterior. Os conceitos são: insuficiente, quan-\ndo o crescimento é menor que 1%; regular, \nquando o crescimento é maior ou igual a 1% e \nmenor que 5%; bom, quando o crescimento é \nmaior ou igual a 5% e menor que 10%; ótimo, \nquando é maior ou igual a 10% e menor que \n20%; e excelente, quando é maior ou igual a \n20%. Essa empresa apresentou lucro de R$ 132 \n000,00 em 2008 e de R$ 145 000,00 em 2009. \n \nDe acordo com esse sistema de controle de \nqualidade, o desempenho financeiro dessa em-\npresa no ano de 2009 deve ser considerado: \n \nA) insuficiente.        \nB) regular.        \nC) bom.        \nD) ótimo.        \nE) excelente.",
    "alternativas": {
      "D": "ótimo.",
      "A": "insuficiente.",
      "B": "regular.",
      "C": "bom."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 154,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0155",
    "numero": 1655,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Uma escola recebeu do governo uma verba de \nR$ 1000,00 para enviar dois tipos de folhetos \npelo correio.  O diretor da escola pesquisou que \ntipos de selos deveriam ser utilizados. Concluiu \nque, para o primeiro tipo de folheto, bastava um \nselo de R$ 0,65 enquanto para folhetos do se-\ngundo tipo seriam necessários três selos, um de \nR$ 0,65, um de R$ 0,60 e um de R$ 0,20. O \ndiretor solicitou que se comprassem selos de \nmodo que fossem postados exatamente 500 \nfolhetos do segundo tipo e uma quantidade res-\ntante de selos que permitisse o envio do máxi-\nmo possível de folhetos do primeiro tipo. \n \nQuantos selos de R$ 0,65 foram comprados? \n \nA) 476        \nB) 675        \nC) 923        \nD) 965        \nE) 1 538",
    "alternativas": {
      "C": "923",
      "D": "965",
      "E": "1 538",
      "B": "675"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 155,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0156",
    "numero": 1656,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "A figura a seguir é a representação de uma \nregião por meio de curvas de nível, que são \ncurvas fechadas representando a altitude da \nregião, com relação ao nível do mar. As coorde-\nnadas estão expressas em graus de acordo \ncom a longitude, no eixo horizontal, e a latitude, \nno eixo vertical. A escala em tons de cinza de-\nsenhada à direita está associada à altitude da \nregião. \n \n \n \nUm pequeno helicóptero usado para reconhe-\ncimento sobrevoa a região a partir do ponto      \nX = (20; 60). O helicóptero segue o percurso: \n \n \n \nAo final, desce verticalmente até pousar no solo. \nDe acordo com as orientações, o helicóptero \npousou em um local cuja altitude é: \n \nA) menor ou igual a 200 m. \nB) maior que 200 m e menor ou igual a 400 m. \nC) maior que 400 m e menor ou igual a 600 m. \nD) maior que 600 m e menor ou igual a 800 m. \nE) maior que 800 m.",
    "alternativas": {
      "E": "maior que 800 m.",
      "A": "menor ou igual a 200 m.",
      "C": "maior que 400 m e menor ou igual a 600 m.",
      "D": "maior que 600 m e menor ou igual a 800 m."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 156,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0157",
    "numero": 1657,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Para construir uma manilha de esgoto, um cilin-\ndro com 2 m de diâmetro e 4 m de altura (de \nespessura desprezível), foi envolvido homoge-\nneamente por uma camada de concreto, con-\ntendo 20 cm de espessura. \n \nSupondo que cada metro cúbico de concreto \ncuste R$ 10,00 e tomando 3,1 como valor apro-\nximado de 𝜋, então o preço dessa manilha é \nigual a: \n \nA) R$ 230,40.        \nB) R$ 124,00.        \nC) R$ 104,16.        \nD) R$ 54,56.        \nE) R$ 49,60.",
    "alternativas": {
      "D": "R$ 54,56.",
      "E": "R$ 49,60.",
      "A": "R$ 230,40.",
      "B": "R$ 124,00."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 157,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0158",
    "numero": 1658,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "No manejo sustentável de florestas, é preciso \nmuitas vezes obter o volume da tora que pode \nser obtida a partir de uma árvore. Para isso, \nexiste um método prático, em que se mede a \ncircunferência da árvore à altura do peito de um \nhomem (1,30 m), conforme indicado na figura. A \nessa medida denomina-se “rodo” da árvore. O \nquadro a seguir indica a fórmula para se cubar, \nou seja, obter o volume da tora em m³ a partir \nda  medida do rodo e da altura da árvore. \n \n \n \nUm técnico em manejo florestal recebeu a mis-\nsão de cubar, abater e transportar cinco toras \nde madeira, de duas espécies diferentes, sendo: \n \n- 3 toras da espécie I, com 3 m de rodo, 12 m de \ncomprimento e densidade 0,77 toneladas/m3. \n \n- 2 toras da espécie II, com 4 m de rodo, 10 m \nde comprimento e densidade 0,78 toneladas/ \nm3. \n \nApós realizar seus cálculos, o técnico solicitou \nque enviassem caminhões para transportar uma \ncarga de, aproximadamente, \n \nA) 29,9 toneladas. \nB) 31,1 toneladas. \nC) 32,4 toneladas. \nD) 35,3 toneladas. \nE) 41,8 toneladas.",
    "alternativas": {
      "B": "31,1 toneladas.",
      "C": "32,4 toneladas.",
      "E": "41,8 toneladas.",
      "A": "29,9 toneladas."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 158,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0159",
    "numero": 1659,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Embora o Índice de Massa Corporal (IMC) seja \namplamente utilizado, existem ainda inúmeras \nrestrições teóricas ao uso e às faixas de norma-\nlidade preconizadas. \n \nO Recíproco do Índice Ponderal (RIP), de acor-\ndo com o modelo alométrico, possui uma melhor \nfundamentação matemática, já que a massa é \numa variável de dimensões cúbicas e a altura, \numa variável de dimensões lineares. \n \nAs fórmulas que determinam esses índices são: \n \n \n \nSe uma menina, com 64 kg de massa, apresen-\nta IMC igual a 25 kg/m², então ela possui RIP \nigual a: \nA) 0,4 cm/kg1/3 \nB) 2,5 cm/kg1/3 \nC) 8 cm/kg1/3 \nD) 20 cm/kg1/3 \nE) 40 cm/kg1/3",
    "alternativas": {
      "E": "40 cm/kg1/3",
      "B": "2,5 cm/kg1/3",
      "C": "8 cm/kg1/3",
      "D": "20 cm/kg1/3"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 159,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0160",
    "numero": 1660,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Um balão atmosférico, lançado em Bauru (343 \nquilômetros a Noroeste de São Paulo), na noite \ndo último domingo, caiu nesta segunda-feira em \nCuiabá Paulista, na região de Presidente Pru-\ndente, assustando agricultores da região. O \nartefato faz parte do programa Projeto Hibiscus, \ndesenvolvido por Brasil, França, Argentina, In-\nglaterra e Itália, para a medição do comporta-\nmento da camada de ozônio, e sua descida se \ndeu após o cumprimento do tempo previsto de \nmedição. \n \n \n \nNa data do acontecido, duas pessoas avistaram \no balão. Uma estava a 1,8 km da posição verti-\ncal do balão e o avistou sob um ângulo de 60°; \na outra estava a 5,5 km da posição vertical do \nbalão, alinhada com a primeira, e no mesmo \nsentido, conforme se vê na figura, e o avistou \nsob um ângulo de 30°. \n \nQual a altura aproximada em que se encontrava \no balão? \n \nA) 1,8 km       \nB) 1,9 km        \nC) 3,1 km        \nD) 3,7 km         \nE) 5,5 km",
    "alternativas": {
      "D": "3,7 km",
      "E": "5,5 km",
      "B": "1,9 km",
      "C": "3,1 km"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 160,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0161",
    "numero": 1661,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Em canteiros de obras de construção civil é \ncomum perceber trabalhadores realizando me-\ndidas de comprimento e de ângulos e fazendo \ndemarcações por onde a obra deve começar ou \nse erguer. Em um desses canteiros foram feitas \nalgumas marcas no chão plano. Foi possível \nperceber que, das seis estacas colocadas, três \neram vértices de um triângulo retângulo e as \noutras três eram os pontos médios dos lados \ndesse triângulo, conforme pode ser visto na \nfigura, em que as estacas foram indicadas por \nletras. \n \n \nA região demarcada pelas estacas A, B, M e N \ndeveria ser calçada com concreto. \n \nNessas condições, a área a ser calçada corres-\nponde: \n \nA) à mesma área do triângulo AMC. \nB) à mesma área do triângulo BNC. \nC) à metade da área formada pelo triângulo \nABC. \nD) ao dobro da área do triângulo MNC. \nE) ao triplo da área do triângulo MNC.",
    "alternativas": {
      "C": "à metade da área formada pelo triângulo ABC.",
      "D": "ao dobro da área do triângulo MNC.",
      "E": "ao triplo da área do triângulo MNC.",
      "A": "à mesma área do triângulo AMC."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 161,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0162",
    "numero": 1662,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "O jornal de certa cidade publicou em uma pági-\nna inteira a seguinte divulgação de seu caderno \nde classificados. \n \n \n \nPara que a propaganda seja fidedigna à porcen-\ntagem da área que aparece na divulgação, a \nmedida do lado do retângulo que representa os \n4%, deve ser de aproximadamente: \n \nA) 1 mm.        \nB) 10 mm.        \nC) 17 mm.        \nD) 160 mm.        \nE) 167 mm.",
    "alternativas": {
      "E": "167 mm.",
      "A": "1 mm.",
      "B": "10 mm.",
      "D": "160 mm."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 162,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0163",
    "numero": 1663,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "A ideia de usar rolos circulares para deslocar \nobjetos pesados provavelmente surgiu com os \nantigos egípcios ao construírem as pirâmides. \n \n \nRepresentando por R o raio da base dos rolos \ncilíndricos, em metros, a expressão do deslo-\ncamento horizontal y do bloco de pedra em fun-\nção de R, após o rolo ter dado uma volta com-\npleta sem deslizar, é: \n \nA) y = R \nB) y = 2R \nC) y = 𝜋R \nD) y = 2𝜋R \nE) y = 4𝜋R",
    "alternativas": {
      "E": "y = 4𝜋R",
      "A": "y = R",
      "B": "y = 2R",
      "C": "y = 𝜋R"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 163,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0164",
    "numero": 1664,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Uma metalúrgica recebeu uma encomenda para \nfabricar, em grande quantidade, uma peça com \no formato de um prisma reto com base triangu-\nlar, cujas dimensões da base são 6 cm, 8 cm e \n10 cm e cuja altura é 10 cm. Tal peça deve ser \nvazada de tal maneira que a perfuração na for-\nma de um cilindro circular reto seja tangente às \nsuas faces laterais, conforme mostra a figura. \n \nO raio da perfuração da peça é igual a: \n \nA) 1 cm.        \nB) 2 cm.        \nC) 3 cm.        \nD) 4 cm.         \nE) 5 cm.",
    "alternativas": {
      "C": "3 cm.",
      "D": "4 cm.",
      "A": "1 cm.",
      "B": "2 cm."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 164,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0165",
    "numero": 1665,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Nos processos industriais, como na indústria de \ncerâmica, é necessário o uso de fornos capazes \nde produzir elevadas temperaturas e, em muitas \nsituações, o tempo de elevação dessa tempera-\ntura deve ser controlado, para garantir a quali-\ndade do produto final e a economia no proces-\nso. \nEm uma indústria de cerâmica, o forno é pro-\ngramado para elevar a temperatura ao longo do \ntempo de acordo com a função: \n \n \n \nEm que T é o valor da temperatura atingida pelo \nforno, em graus Celsius, e t é o tempo, em mi-\nnutos, decorrido desde o instante em que o \nforno é ligado. \n \nUma peça deve ser colocada nesse forno quan-\ndo a temperatura for 48 °C e retirada quando a \ntemperatura for 200 °C. O tempo de permanên-\ncia dessa peça no forno é, em minutos, igual a: \n \nA) 100.        \nB) 108.        \nC) 128.        \nD) 130.        \nE) 150.",
    "alternativas": {
      "D": "130.",
      "E": "150.",
      "B": "108.",
      "C": "128."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 165,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0166",
    "numero": 1666,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "O gráfico mostra o número de favelas no muni-\ncípio do Rio de Janeiro entre 1980 e 2004, con-\nsiderando que a variação nesse número entre \nos anos considerados é linear. \n \n \n \nSe o padrão na variação do período 2004/2010 \nse mantiver nos próximos 6 anos, e sabendo \nque o número de favelas em 2010 é 968, então \no número de favelas em 2016 será: \n \nA) menor que 1150. \nB) 218 unidades maior que em 2004. \nC) maior que 1150 e menor que 1200. \nD) 177 unidades maior que em 2010. \nE) maior que 1200.",
    "alternativas": {
      "A": "menor que 1150.",
      "C": "maior que 1150 e menor que 1200.",
      "D": "177 unidades maior que em 2010.",
      "E": "maior que 1200."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 166,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0167",
    "numero": 1667,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "O gráfico apresenta a quantidade de gols mar-\ncados pelos artilheiros das Copas do Mundo \ndesde a Copa de 1930 até a de 2006. \nQuantidades de Gols dos Artilheiros \ndas Copas do Mundo \n \n \n \nA partir dos dados apresentados, qual a media-\nna das quantidades de gols marcados pelos \nartilheiros das Copas do Mundo? \n \nA) 6 gols.        \nB) 6,5 gols.        \nC) 7 gols.         \nD) 7,3 gols.         \nE) 8,5 gols.",
    "alternativas": {
      "B": "6,5 gols.",
      "D": "7,3 gols.",
      "E": "8,5 gols.",
      "A": "6 gols."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 167,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0168",
    "numero": 1668,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Em um casamento, os donos da festa serviam \nchampanhe aos seus convidados em taças com \nformato de um hemisfério (Figura 1), porém um \nacidente na cozinha culminou na quebra de \ngrande parte desses recipientes. Para substituir \nas taças quebradas, utilizou-se um outro tipo \ncom formato de cone (Figura 2). No entanto, os \nnoivos solicitaram que o volume de champanhe \nnos dois tipos de taças fosse igual. \n \n \n \nConsidere: \n \n \n \nSabendo que a taça com o formato de hemisfé-\nrio é servida completamente cheia, a altura do \nvolume de champanhe que deve ser colocado \nna outra taça, em centímetros, é de: \n \nA) 1,33.        \nB) 6,00.        \nC) 12,00.        \nD) 56,52.         \nE) 113,04.",
    "alternativas": {
      "C": "12,00.",
      "E": "113,04.",
      "A": "1,33.",
      "B": "6,00."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 168,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0169",
    "numero": 1669,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "O Salto Triplo é uma modalidade do atletismo \nem que o atleta dá um salto em um só pé, uma \npassada e um salto, nessa ordem. Sendo que o \nsalto com impulsão em um só pé será feito de \nmodo que o atleta caia primeiro sobre o mesmo \npé que deu a impulsão; na passada ele cairá \ncom o outro pé, do qual o salto é realizado. \n \nUm atleta da modalidade Salto Triplo, depois de \nestudar seus movimentos, percebeu que, do \nsegundo para o primeiro salto, o alcance dimi-\nnuía em 1,2 m, e, do terceiro para o segundo \nsalto, o alcance diminuía 1,5 m. Querendo atin-\ngir a meta de 17,4 m nessa prova e consideran-\ndo os seus estudos, a distância alcançada no \nprimeiro salto teria de estar entre: \n \nA) 4,0 m e 5,0 m. \nB) 5,0 m e 6,0 m. \nC) 6,0 m e 7,0 m. \nD) 7,0 m e 8,0 m. \nE) 8,0 m e 9,0 m.",
    "alternativas": {
      "B": "5,0 m e 6,0 m.",
      "C": "6,0 m e 7,0 m.",
      "D": "7,0 m e 8,0 m.",
      "A": "4,0 m e 5,0 m."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 169,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0170",
    "numero": 1670,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Marco e Paulo foram classificados em um con-\ncurso. Para classificação no concurso o candi-\ndato deveria obter média aritmética na pontua-\nção igual ou superior a 14. Em caso de empate \nna média, o desempate seria em favor da pon-\ntuação mais regular. No quadro a seguir são \napresentados os pontos obtidos nas provas de \nMatemática, Português e Conhecimentos Ge-\nrais, a média, a mediana e o desvio padrão dos \ndois candidatos. \n \nDados dos candidatos no concurso \n \n \n \nO candidato com pontuação mais regular, por-\ntanto mais bem classificado no concurso, é: \n \nA) Marco, pois a média e a mediana são iguais. \nB) Marco, pois obteve menor desvio padrão. \nC) Paulo, pois obteve a maior pontuação da \ntabela, 19 em Português. \nD) Paulo, pois obteve maior mediana. \nE) Paulo, pois obteve maior desvio padrão.",
    "alternativas": {
      "C": "Paulo, pois obteve a maior pontuação da tabela, 19 em Português.",
      "D": "Paulo, pois obteve maior mediana.",
      "E": "Paulo, pois obteve maior desvio padrão.",
      "B": "Marco, pois obteve menor desvio padrão."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 170,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0171",
    "numero": 1671,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Um grupo de pacientes com Hepatite C foi sub-\nmetido a um tratamento tradicional em que 40% \ndesses pacientes foram completamente cura-\ndos. Os pacientes que não obtiveram cura fo-\nram distribuídos em dois grupos de mesma \nquantidade e submetidos a dois tratamentos \ninovadores. No primeiro tratamento inovador, \n35% dos pacientes foram curados e, no segun-\ndo, 45%. Em relação aos pacientes submetidos \ninicialmente, os tratamentos inovadores propor-\ncionaram cura de: \n \nA) 16%.        \nB) 24%.         \nC) 32%.         \nD) 48%.          \nE) 64%.",
    "alternativas": {
      "B": "24%.",
      "D": "48%.",
      "E": "64%.",
      "A": "16%."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 171,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0172",
    "numero": 1672,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Em 2006, a produção mundial de etanol foi de \n40 bilhões de litros e a de biodiesel, de 6,5 bi-\nlhões. Neste mesmo ano, a produção brasileira \nde etanol correspondeu a 43 % da produção \nmundial, ao passo que a produção dos Estados \nUnidos da América, usando milho, foi de 45 %. \n \nConsiderando que, em 2009, a produção mun-\ndial de etanol seja a mesma de 2006 e que os \nEstados Unidos produzirão somente a metade \nde sua produção de 2006, para que o total pro-\nduzido pelo Brasil e pelos Estados Unidos con-\ntinue correspondendo a 88% da produção mun-\ndial, o Brasil deve aumentar sua produção em, \naproximadamente, \n \nA) 22,5%.        \nB) 50,0%.        \nC) 52,3%.         \nD) 65,5%.           \nE) 77,5%.",
    "alternativas": {
      "B": "50,0%.",
      "C": "52,3%.",
      "E": "77,5%.",
      "A": "22,5%."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 172,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0173",
    "numero": 1673,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "João mora na cidade A e precisa visitar cinco \nclientes, localizados em cidades diferentes da \nsua. Cada trajeto possível pode ser representa-\ndo por uma sequência de 7 letras. Por exemplo, \no trajeto ABCDEFA, informa que ele sairá da \ncidade A, visitando as cidades B, C, D, E e F \nnesta ordem, voltando para a cidade A. Além \ndisso, o número indicado entre as letras informa \no custo do  deslocamento entre as cidades. a \nfigura mostra o custo de deslocamento entre \ncada uma das cidades. \nComo João quer economizar, ele precisa de-\nterminar qual o trajeto de menor custo para visi-\ntar os cinco clientes. Examinando a figura, per-\ncebe que precisa considerar somente parte das \nsequências, pois os trajetos ABCDEFA e \nAFEDCBA têm o mesmo custo. Ele gasta \n1min30s para examinar uma sequência e des-\ncartar sua simétrica, conforme apresentado. \n \nO tempo mínimo necessário para João verificar \ntodas as sequências possíveis no problema é \nde \n \nA) 60 min.       \nB) 90 min.       \nC) 120 min.        \nD) 180 min.         \nE) 360 min.",
    "alternativas": {
      "E": "360 min.",
      "A": "60 min.",
      "B": "90 min.",
      "C": "120 min."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2010.1",
    "numeroOriginal": 173,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];